export default class UrlUtils {
  static getUrlParam(key: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
  }
}
